import React from "react";
import { Typography, Box, useTheme } from "@mui/material";
import { useParams } from "react-router-dom";

import Header from "../../components/Header";
import RealTimeClock from "../../components/Time";
import CheckinPage from "../../components/Checkin";
import UserImage from "../../components/UserImage";
import { cobotColours } from "../../theme/theme";

const LoginPage = () => {
    const cobotTheme = useTheme();
    const colors = cobotColours(cobotTheme.palette);
    const { id } = useParams();

    return (
        <Box
            height="100vh"
            display="flex"
            flexDirection="column"
            backgroundColor={colors.primary.special}
            padding={2}
        >
            {/* Header Section */}
            <Box
                display="flex"
                justifyContent="center"
                alignItems="center"
                textAlign="center"
                backgroundColor={colors.primary.teal}
            >
                <Header title="ENTER YOUR PIN TO CLOCK IN" />
            </Box>

            {/* Main Content */}
            <Box flex={1} display="flex" padding="10px 0" gap={2}>
                {/* Left Panel */}
                <Box width={{ xs: "100%", md: "25%" }} display="flex" flexDirection="column" gap={2}>
                    <Box
                        width="100%"
                        height="100px"
                        borderRadius="10px"
                        backgroundColor={colors.grey.lighter}
                        display="flex" justifyContent="center"
                        alignItems="center"
                    >
                        <RealTimeClock />
                    </Box>
                    <Box
                        flex={0.5}
                        borderRadius="10px"
                        textAlign="center"
                        backgroundColor={colors.grey.lighter}
                        display="flex"
                        justifyContent="center"
                        flexDirection="column"
                        alignItems="center"
                    >
                        <UserImage />
                        <Typography> This is my name</Typography>
                    </Box>
                </Box>

                {/* Right Panel */}
                <Box flex={1} display="flex" flexDirection="column" gap={2}>
                    {/* Clock In Pin */}
                    <Box flex={1} overflow="hidden">
                        <CheckinPage userID={id} />
                    </Box>
                </Box>
            </Box>
        </Box>
    );
};

export default LoginPage;
